interface BusinessInfoFooterProps {
  companyNumber?: string | null;
  mailOrderNumber?: string | null;
  ceoName?: string | null;
  bizProfileName?: string | null;
  companyName?: string | null;
}

const BusinessInfoFooter = ({
  companyNumber,
  mailOrderNumber,
  ceoName,
  bizProfileName,
  companyName,
}: BusinessInfoFooterProps) => {
  // 모든 값이 없으면 렌더링하지 않음
  if (!companyNumber && !mailOrderNumber && !ceoName && !bizProfileName && !companyName) {
    return null;
  }

  return (
    <div
      style={{
        width: "100%",
        padding: "24px 16px",
        backgroundColor: "#f8f9fa",
        fontSize: "12px",
        color: "#666",
        lineHeight: 1.8,
        boxSizing: "border-box",
        textAlign: "left",
      }}
    >
      <div>
        사업자 번호 : {companyNumber || "-"} | 통신판매번호 {mailOrderNumber || "-"}
      </div>
      <div>
        사업자명 : {companyName || "-"} | 서비스명 : {bizProfileName || "-"}
      </div>
      <div>대표자 : {ceoName || "-"}</div>
      {bizProfileName && companyName && (
        <div style={{ marginTop: "12px" }}>
          {bizProfileName}은 {companyName}에서 운영하는 서비스입니다.
        </div>
      )}
    </div>
  );
};

export default BusinessInfoFooter;
